const common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

export { common$1 as default };
//# sourceMappingURL=common.js.map
